import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';

import {
  Uppy,
  UppyFile,
} from '@uppy/core';
// import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard';

@Component({
  selector: 'app-image-add',
  templateUrl: './image-add.component.html',
  styleUrls: ['./image-add.component.scss'],
})
export class ImageAddComponent implements OnInit {

  // @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  // uppy: Uppy = new Uppy({ debug: true, autoProceed: true })

  @Output() insert_images:any = new EventEmitter();
  @Output() insert_image_attribute:any = new EventEmitter();
  up_py = new Uppy()
  uppy: Uppy = new Uppy;

  onBeforeUpload = (files: { [key: string]: UppyFile<{}, {}> }) => {
    // if (this.filesAlreadyChecked) {
    //   return true;
    // }
    // you can check the files here
    return true;
  };
  
  constructor() { }

  ngOnInit() {
    this.uppy = new Uppy({
      onBeforeUpload: this.onBeforeUpload, restrictions:{
          maxFileSize: 1000000,
          allowedFileTypes:['image/*','.jpg','.png','.jpeg','.gif', '.webp']
        }
    })
    .use(Dashboard, {
        trigger:'#select-files',
        inline: true,
        width: 550,
        height: 450,
        note: 'Images only, up to 1 MB',
        target: '#image-area',
        // disableInformer: false,
        // animateOpenClose: true,
        metaFields: [
          {
            id: 'name',
            name: 'Name',
            placeholder: 'FileName',
          },
        ],
        browserBackButtonClose: true,
        proudlyDisplayPoweredByUppy: false,
        // onRequestCloseModal: this.cancelModal,
        locale: {
          strings: {}, // translatations,
        },
      })
      // .use(XHRUpload, { endpoint: 'https://api2.transloadit.com' })
      // .use(Tus, { endpoint: this.DBservice.domainMethodUrl + 'ecommerce_business_store.ecommerce_business_store.api.update_to_file',})

    this.uppy.on('upload', (result) => {
      let files_count = this.uppy.getFiles().length;
      let all_files = this.uppy.getFiles();
      this.insert_images.emit(all_files)
      this.insert_image_attribute.emit(all_files)
      console.log('Upload complete! We’ve uploaded these files:', result)
    })
  }

  
  ionViewWillLeave(){
    this.uppy.close();
  }

}
